/** `18:42`, or `1:05:09` past an hour. Rounds UP, so 0:00 means done. */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = String(total % 60).padStart(2, '0');
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${seconds}`;
  }
  return `${minutes}:${seconds}`;
}

/** Whole minutes, never below 1 for a credited block. */
export function toMinutes(ms: number): number {
  return Math.max(0, Math.round(ms / 60_000));
}

/** `1 min` / `25 min` / `1 h 15 min`. */
export function formatMinutes(ms: number): string {
  const minutes = toMinutes(ms);
  if (minutes < 60) return `${minutes} min`;
  const rest = minutes % 60;
  return rest
    ? `${Math.floor(minutes / 60)} h ${rest} min`
    : `${minutes / 60} h`;
}

/** `3:19 PM` in the student's own locale and clock. */
export function formatTimeOfDay(ms: number): string {
  return new Date(ms).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** "5:05 PM", or "12:40 AM tomorrow" when the end falls on the next day. */
export function formatEndTime(now: number, end: number): string {
  const sameDay = new Date(now).toDateString() === new Date(end).toDateString();
  return sameDay ? formatTimeOfDay(end) : `${formatTimeOfDay(end)} tomorrow`;
}
